<template>
    <div v-if="softwareInfo">
        <section class="main-slider">
            <div class="page-header-bg" :style="{backgroundImage: softwareInfo.bannerUrl}">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- {{ softwareInfo.title }}  -->
                          {{  $t(`software.${softwareInfo.i18n_title}`) }}
                        <span style="color: var(--bs-orange);">{{ softwareInfo.title_abb }}</span></h1> 
					<div class="page-header__inner_text page-header__inner_en" style="font-weight: bold;">{{ softwareInfo.title_en }}</div>
                    <div class="page-header__inner_text">
                        <!-- {{ softwareInfo.text }} -->
                           {{  $t(`software.${softwareInfo.i18n_text}`) }}
                    </div>
                </div>
                
            </div>
        </section>
      

		<section class="blog-details">
            <div class="container">

                   <!-- 主要功能 -->
                <div class="row" v-if="softwareInfo.i18n_functionImgUrl">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.functionTitle }} -->
                             {{  $t(`software.${softwareInfo.i18n_functionImgTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" style="text-align: center;">
                        <img class="row_img" :src="softwareInfo.i18n_functionImgUrl" />
                    </div>
                </div>
                 <!-- 功能 -->
                <div class="row"  v-if="softwareInfo.mainFunctionShow">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.mainFunctionTitle }} -->
                                 {{  $t(`software.${softwareInfo.i18n_mainFunctionTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div v-for="(item, index) in softwareInfo.i18n_mainFunctionList" :key="index">
                        <div class="col-xl-6 col-lg-12 wow fadeInUp" >
                            <div class="row_align">
                                <p class="rf_title">
                                    <!-- {{ item.title }} -->
                                       {{  $t(`software.${item.title}`) }}
                                </p>
                                <p class="rf_text rfc_margin">
                                    <!-- {{ item.text }} -->
                                        {{  $t(`software.${item.text}`) }}
                                </p>
                                 <p class="rf_text rfc_margin" v-if="item.text1">
                                    <!-- {{ item.text }} -->
                                        {{  $t(`software.${item.text1}`) }}
                                </p>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-12 wow fadeInUp" style="text-align: center;">
                                <img class="row_img" :src="item.img" />
                        </div>
                    </div>
                </div>

                <!-- 产品功能（其他功能） -->
				<div class="row" v-if="softwareInfo && softwareInfo.i18n_functionList.length">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.functionTitle }} -->
                            {{  $t(`software.${softwareInfo.i18n_functionTitle}`) }}
                            </h3>
                        </div>
                    </div>

                    <div >
                        <div class="col-xl-4 col-lg-6 row_fli"  v-for="(item,index) in softwareInfo.i18n_functionList" :key="index">
                            <div class="row_fli_item">
                                <div class="row_fli_title">
                                    <p>
                                        <!-- {{ item.title }} -->
                                        {{  $t(`software.${item.title}`) }}
                                    </p>
                                    <div></div>
                                </div>
                                <div class="row_fli_text">
                                    <p>
                                        <!-- {{ item.text }} -->
                                        {{  $t(`software.${item.text}`) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- 小程序功能 -->
                <div class="row" v-if="softwareInfo.i18n_funtionAppletUrl">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.funtionAppletTitle }} -->
                                   {{  $t(`software.${softwareInfo.i18n_funtionAppletTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" style="text-align: center;">
                       <!-- <div class="row_img"> -->
                            <img class="row_img" :src="softwareInfo.i18n_funtionAppletUrl" />
                       <!-- </div> -->
                    </div>

                </div>
                <!-- 招聘流程 -->
                <div class="row" v-if="softwareInfo.i18n_flowPathUrl">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.flowPathTitle }} -->
                                 {{  $t(`software.${softwareInfo.i18n_flowPathTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                       <!-- <div class="row_img"> -->
                            <img class="row_img" :src="softwareInfo.i18n_flowPathUrl" />
                       <!-- </div> -->
                    </div>

                </div>
                <!-- 产品价值 -->
                <div class="row" v-if="softwareInfo.valueShow" style="margin-bottom: 50px;">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- 产品价值 -->

                                {{  $t('software.product_value') }}
                            </h3>
                        </div>
                    </div>
                    <div>
                        <el-carousel  :autoplay="false" arrow="always">
                            <el-carousel-item v-for="(item,index) in softwareInfo.i18n_valueList" :key="index">
                                <div class="r_value">
                                    <div class="r_value_img">
                                        <img  :src="item.mbUrl" alt="">
                                    </div>
                                    <div class="row_value_text">
                                        <div class="rvt_item">
                                            <span class="rvt_icon"><i></i></span>
                                            <div class="rvt_item_title">
                                                <!-- {{ item.title }} -->
                                                {{  $t(`software.${item.title}`) }}
                                            </div>
                                            <div class="rvt_item_text">
                                                <p>
                                                    <!-- {{ item.text  }} -->
                                                {{  $t(`software.${item.text}`) }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                </div>
			</div> 
            <!-- 对比 -->
            <div class="row_contrast" v-if="softwareInfo.i18n_contrastTitle" :style="{ backgroundImage: softwareInfo.contrastBgUrl}">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12" >
                            <div class="row__title">
                                <!-- <h3>{{ softwareInfo.contrastTitle }}</h3> -->

                                <h3>{{  $t(`software.${softwareInfo.i18n_contrastTitle}`) }}</h3>
                            </div>
                        </div>
                      
                    </div>
                    <div class="contrast_row" v-if="!softwareInfo.contrastImgShow">
                        <div class="col-xl-2 col-lg-12 contrast_item" v-for="(item,index) in softwareInfo.i18n_contrastList" :key="index">
                            <div class="contrast_item_title" style="">
                                <!-- {{ item.title }} -->
                                   {{  $t(`software.${item.title}`) }}
                            </div>
                            <div class="contrast_item_text" style=" ">{{ item.text }}<span style="font-size: 15px;">%</span></div>
                        </div>
                    </div>


                    <div class="row" v-if="softwareInfo.contrastImgShow">
                        <div class="col-xl-12 col-lg-12" >
                                <img class="row_img" :src="softwareInfo.i18n_contrastUrl" />
                        </div>
                    </div>
                   
                </div>
            </div>
		</section>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbSoftware',
     mixins: [MixinsList],
    data () {
        return {          
            softwareInfo: null,  // 信息
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () { },
    methods: {
        // 获取内容
         async getList() {
             try {
             const software = await loadData('productSoftware', this.lang)

           	this.softwareInfo = software[this.$route.query.type]

             } catch (error) {
                console.error('[mbsoftware] 加载失败:', error)
                this.softwareInfo = {}
            }
            // const { result } = res
           	// this.softwareInfo = result.software[this.$route.query.type]

            // if(this.$i18n.locale == 'zh_CN') {
            //     this.softwareInfo.i18n_contrastUrl = this.softwareInfo.contrastUrl  // 产品价值图片
            // } else if(this.$i18n.locale == 'en_US') {
            //     this.softwareInfo.i18n_contrastUrl = this.softwareInfo.contrastUrl_en  // 产品价值图片
            // }else if(this.$i18n.locale == 'ru_RU') {

            // }
        },


       
    }
}
</script>
<style scoped>
.blog-details {
    padding: 0px 0 0px;
}
body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: transparent; 
}

/* 头部介绍 */
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}

.page-header__inner h1{
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
 }

.page-header__inner_text{
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }
 .page-header__inner_en {
    text-align: center;
    font-size: 14px;
 }

.row__title {
    margin: 45px 0;
    text-align: center;
    font-size: var(--font-size-30);
    line-height: 50px;
    color: #232e5e;
}
.row__title h3{
    font-size: var(--font-size-30);
    line-height: 50px;
    font-weight: bold;
}
/* 图片尺寸 */
.row_img {
    max-width: 100%;
}


/* 产品价值 */
.r_value {
    width: 100%;
    visibility: visible;
    animation-name: ysfadeInUp0;
    animation: ysfadeInUp0 .5s ease-in-out 1 both;
    animation-delay: 0.2s;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}
.r_value_img {
    /* display: flex; */
    width: 100%;
    position: relative;
    display: block;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}
.r_value_img img {
    max-width: 100%;
    height: 260px;
}
::v-deep .el-carousel__container {
    height: 260px;
}
.row_value_text {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
} 

.rvt_item {
    width: 100%;
    padding-top: 20px;
}
.rvt_icon{
  
    display: block;
    width: 60px;
    height: 60px;
    opacity: 1;
    transition: .1s;
    transform: translateZ(0);
    margin: 0 auto;
}
.rvt_icon:before {
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.75);
    transition: .4s;
    border: 1px solid hsla(0, 0%, 100%, .3);
    border-radius: 100%;
    height: 40px;
    width: 40px;
}
.rvt_icon i{
    background: hsla(0, 0%, 100%, .8);
    border: 1px solid #fff;
    border-radius: 100%;
    height: 22px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.5);
    transition: .4s;
    width: 22px;
}
.rvt_icon:after {
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.75);
    transition: .4s;
    border: 1px solid hsla(0, 0%, 100%, .1);
    border-radius: 100%;
    height: 60px;
    width: 60px;
}

.rvt_item_title {
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
    color: #fff;
    font-weight: bold;
}
.rvt_item_text {
    
    width: 70%;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    line-height: 1.35;
    color: #fff;
    display: block;
    margin-top: 10px;
}






/* 产品功能-具体介绍 */
.rf_title {
    text-align: center;
    line-height: 40px;
    margin-top: 10px;
    font-size: var(--font-size-24);
    font-weight: bold;
}
.rfc_margin {
    margin-top: 20px;
}

.rf_text {
    line-height: 30px;
    font-size: var(--font-size-16);
    font-weight: bold;
}

/* 功能列表 */
.row_fli {
 padding: 15px;
}
.row_fli_item {
    box-shadow: 0 0 10px 3px rgba(19, 55, 159, .08);
    padding: 20px 30px 20px;
}
.row_fli_title p{
    font-size: var(--font-size-20);
    line-height: 50px;
    font-weight: bold;
}
.row_fli_title div {
    /* margin-top: 10px; */
    width: 40px;
    height: 3px;
    border-radius: 1px;
    background: var(--notech-base);
}
.row_fli_text {
    height: 80px;
    margin-top: 15px;
}
.row_fli_text p{
    color: #666666;
   font-size: 14px;
   font-weight: bold;
   line-height: 1.2;
}

/* 系统对比 */
.row_contrast {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-top: 50px;
    padding-bottom: 50px;
    width: 100%;
}
.contrast_row {
    background-color: #fff;  
    box-shadow: 0 0 10px 3px rgba(19, 55, 159, .08); 
    padding: 20px 0; 
    display: flex;     
    justify-content: space-around;
}
.contrast_item {
    /* width: 15%;  */
    text-align: center;
    margin: 20px 0;
}
.contrast_item_title {
    line-height: 15px;
    font-size: 10px; 
    font-weight: 600; 
    margin-bottom: 15px;
}
.contrast_item_text {
    font-size: 30px;
    color: var(--notech-base); 
    font-weight: 700;
}
</style> 
